module.exports = __webpack_public_path__ + "img/11-jia.20b5fd48.png";